export const INVENTORY_SELECTION_MODE_PARAM = 'selectionMode'

export const enum AssetSelectionEnum {
  Convert = 'convert',
  Transfer = 'transfer'
}

export type AssetSelectionMode =
  | AssetSelectionEnum.Convert
  | AssetSelectionEnum.Transfer

export type AssetSelectionModeParam = {
  [INVENTORY_SELECTION_MODE_PARAM]: AssetSelectionMode
}
